import React, { useState } from 'react';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { Check } from 'lucide-react';
export function Pricing() {
  const [annual, setAnnual] = useState(true);
  const plans = [{
    name: 'Free',
    price: '0',
    desc: 'For individuals trying out Cart Tracker.',
    features: ['Capture up to 10 carts/month', 'Excel export', 'Basic cart capture', 'Email support'],
    cta: 'Install Free',
    variant: 'outline'
  }, {
    name: 'Pro',
    price: annual ? '19' : '25',
    desc: 'For teams that need unlimited captures.',
    features: ['Unlimited cart captures', 'Excel & CSV export', 'API access', 'Custom templates', 'Priority support'],
    cta: 'Start Free Trial',
    variant: 'primary',
    popular: true
  }, {
    name: 'Enterprise',
    price: 'Custom',
    desc: 'For organizations with advanced needs.',
    features: ['Everything in Pro', 'Dedicated account manager', 'Custom integrations', 'SSO authentication', 'SLA guarantee'],
    cta: 'Contact Sales',
    variant: 'secondary'
  }];
  return <div className="pt-20" data-id="element-346">
      <Section className="bg-gradient-to-br from-[#EEF2FF] to-white" data-id="element-347">
        <div className="container mx-auto px-4 text-center" data-id="element-348">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-349">
            Simple, transparent pricing
          </h1>
          <p className="text-xl text-gray-600 mb-8" data-id="element-350">
            Start for free, upgrade as you grow.
          </p>

          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-351">
            <span className={`text-sm font-medium ${!annual ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-352">
              Monthly
            </span>
            <button onClick={() => setAnnual(!annual)} className="relative w-14 h-8 bg-[#6366F1] rounded-full p-1 transition-colors" data-id="element-353">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${annual ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-354"></div>
            </button>
            <span className={`text-sm font-medium ${annual ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-355">
              Annual{' '}
              <span className="text-[#EC4899] text-xs font-bold ml-1" data-id="element-356">
                SAVE 20%
              </span>
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-357">
            {plans.map((plan, i) => <Card key={i} className={`p-8 text-left relative ${plan.popular ? 'border-2 border-[#6366F1] shadow-xl' : ''}`} data-id="element-358">
                {plan.popular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#6366F1] text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-359">
                    Most Popular
                  </div>}
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-360">
                  {plan.name}
                </h3>
                <p className="text-gray-600 text-sm mb-6" data-id="element-361">{plan.desc}</p>
                <div className="flex items-baseline mb-8" data-id="element-362">
                  <span className="text-4xl font-bold text-gray-900" data-id="element-363">
                    {plan.price === 'Custom' ? 'Custom' : `$${plan.price}`}
                  </span>
                  {plan.price !== 'Custom' && <span className="text-gray-500 ml-2" data-id="element-364">/month</span>}
                </div>

                <Button variant={plan.variant as any} className="w-full mb-8" onClick={plan.name === 'Enterprise' ? () => window.open('https://calendly.com/alex-thruline/cart-tracker', '_blank') : undefined} data-id="element-365">
                  {plan.cta}
                </Button>

                <ul className="space-y-4" data-id="element-366">
                  {plan.features.map((feature, f) => <li key={f} className="flex items-start gap-3" data-id="element-367">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-368" />
                      <span className="text-sm text-gray-700" data-id="element-369">{feature}</span>
                    </li>)}
                </ul>
              </Card>)}
          </div>
        </div>
      </Section>
    </div>;
}